import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { SettingsService } from '../.services/settings.service';
import { ConnectionService } from '../.services/connection.service';


@Injectable()
export class ChatService {
  connection: ConnectionService;
  settings: SettingsService;
  chats: any = [
    {name: 'Chat', messages: []},
  ];

  chatList = new BehaviorSubject<any>(this.chats);
  chatListCast = this.chatList.asObservable();



  //move this to connection.service to be publically accessible. 
  findUserByName = (name) => {
    return new Promise((resolve, reject)=>{
      let userExists = this.connection.users.find(x => {
        return(x.username == name);
      });

      if(userExists) {
        console.log('FOUND USER ' + name)
        resolve(userExists)
      } else {
        console.log('COULD NOT FIND USER ' + name)
        reject(false);
      }
    }) 
  }

  findChatInChatList = (name) => {
    return new Promise((resolve, reject) => {
    
      let chatExists = this.chats.find(x => {
        return x.name == name.toLowerCase();
      });

      if(chatExists) {
        resolve(chatExists);
      } else {
        resolve(false);
      }
    });
  }


  sendMessage = () => {

  }

  addTab = (name) => {
    this.chats.push({name: name, messages: []});
    this.updateTabNames();
  }

  selectTab = (name) => {

      let tabContainer = document.getElementById('example-tabs');
      let tabs = tabContainer.getElementsByTagName('a');
      for( var i = 0; i < tabs.length; i++)  {
        if(tabs[i].innerText == name) {
          tabs[i].click();
          tabs[i].parentElement.click();
        } 
      }

  }

  highlightTab = (name) => {
    //replace  with selectTab
    let tabContainer = document.getElementById('example-tabs');
    let tabs = tabContainer.getElementsByTagName('a');
    for( var i = 0; i < tabs.length; i++)  {
      if(tabs[i].innerText == name) {
        tabs[i].classList.add('highlightTab');
      }
    }
  }

  clearTabHighlights = (name) => {
    let tabContainer = document.getElementById('example-tabs');
    let tabs = tabContainer.getElementsByTagName('a');
    let chatButton = document.getElementById('chatButton');
        chatButton.classList.remove('highlightTab');
    for( var i = 0; i < tabs.length; i++)  {
        tabs[i].classList.remove('highlightTab');
    }
  }

  newChatMessageHighlight = () => {
    let chatButton = document.getElementById('chatButton');
    chatButton.classList.add('highlightTab');
  }


  //This isn't working correctly because userList consistently updating the host' s name on guest's list so the conditions fail to meet any criteria.
  addMessage = (to, from, message) => {
    console.log(`to ${to} ______ from ${from} ___________ message: ${message}`)
   let confirmExists = Promise.all([
     this.findUserByName(from), 
     this.findChatInChatList(from) 
    ].map(p =>  p.catch(e=> e)))
      .then(results => {
        if(results[0] && results[1]) { 
          console.log('mode: 1')
          //user is in users list AND there is a chat already open with that name
          if(to == "Chat") {
            console.log('mode: 3')
            //message goes to general chat
            this.highlightTab(to);
            this.newChatMessageHighlight();
            this.chats[0].messages.push({from: from, message: message, time: new Date()});
           
          }  else {
            this.highlightTab(from)
            this.newChatMessageHighlight();
             results[1].messages.push({from: from, message: message, time: new Date()});
          }
        } else if(results[0] && results[1] === false) {
          console.log('mode: 2')
           // found in user list but not in chat list, check if its a message for general chat

          if(to == "Chat") {
            console.log('mode: 3')
            //message goes to general chat
            this.highlightTab(to)
            this.newChatMessageHighlight();
            this.chats[0].messages.push({from: from, message: message, time: new Date()});
           
          } else {
          //found in user list but not in chat list so create a new tab and add the message [recursion]

          this.addTab(from);
          this.addMessage(to, from, message);
          
          }
        } else {
          console.log('mode: 4')
          //do nothing
        }

      }).then(()=>{
        this.updateChats();
      }).catch(e =>{
        console.log('something went wrong with messaging');
        console.log(e);
      });
  }

  updateTabNames = () => {
    let tabContainer = document.getElementById('example-tabs');
    let tabs = tabContainer.getElementsByTagName('a');
    for( var i = 0; i < tabs.length; i++)  {
      if(this.chats[i]) {
        tabs[i].innerHTML = this.chats[i].name;
      }
    }
  }


  updateChats = () => {
    this.chatList.next(this.chats);
    this.updateTabNames();
   
    console.log(this.chats)
  }

  constructor(private connectionService: ConnectionService, private settingsService: SettingsService) { 
    this.settings = settingsService;
    this.connection = connectionService;
 
  }

}
